import styled from 'styled-components';

export const Container = styled.div`
  .card-title {
    color: #495057;
    font-size: 16px;
  }

  .card-text {
    font-size: 24px;
    font-weight: 600;
  }

  .card-list {
    background-color: #f0f1f2 !important;
  }
`;
